import { queryOptions } from '@tanstack/react-query';

import apiClient from '@/constants/http';
import type { HomeResponse } from '@/hooks/queries/home/useHomeQuery/types';

import type { HomeQueryParams } from './types';

const fetchHome = async (
  shopId?: string,
  brandId?: string,
  limit?: number,
  coords?: {
    latitude: number;
    longitude: number;
  },
): Promise<HomeResponse> => {
  const url = brandId ? `/v1/home/${brandId}` : '/v1/home';
  const searchParams = new URLSearchParams();

  searchParams.append('limit', '100');
  if (shopId) searchParams.append('shopId', shopId);
  if (limit) searchParams.set('limit', limit.toString());
  if (coords) {
    searchParams.append('lat', coords.latitude.toString());
    searchParams.append('lng', coords.longitude.toString());
  }

  searchParams.append('include', 'address,staticMap,photos,waitingLists,brand');

  const { data } = await apiClient.get<HomeResponse>(
    `${url}?${searchParams.toString()}`,
  );

  return data;
};

export const homeQuery = ({
  shopId,
  brandId,
  limit,
  location,
}: HomeQueryParams = {}) =>
  queryOptions<HomeResponse>({
    queryKey: [
      'home',
      shopId,
      brandId,
      limit,
      location?.latitude,
      location?.longitude,
    ],
    queryFn: () => fetchHome(shopId, brandId, limit, location),
  });
